
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resigilate/[[...filters]]",
      function () {
        return require("private-next-pages/resigilate/[[...filters]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resigilate/[[...filters]]"])
      });
    }
  